import React, { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import ProjectService from "../services/ProjectService";
import ProjectVehicleService from "../services/ProjectVehicleService";
import VehicleTypeService from "../services/VehicleTypeService";
// import VehicleRegistrationService from "../services/vehicleRegistrationService";
import VehicleHireService from "../services/vehicleHireService";
import StorageService from "../services/StorageService";
import Breadcrumb from "../components/Breadcrumb";
import Loading from "../components/loading";
import ReactPaginate from "react-paginate";
import utility from "../utils/utility";
// import EmployeePermissionService from "../services/EmployeePermissionService";
import ScreenData from "../config/ScreenData";
import { useNavigate } from "react-router-dom";
import usePermission from "../utils/UsePermission";
import UnAuthorized from "../views/Unathorized";
import MessageDialog from "../components/MessageDialog";

export default function AddProjectVehicle() {
  const [projects, setProjects] = useState([]);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [assignedVehicles, setAssignedVehicles] = useState([]);
  // 1. Vehicle Type Filter State
  const [selectedVehicleTypeId, setSelectedVehicleTypeId] = useState("");
  const [vehicleTypeSearch, setVehicleTypeSearch] = useState("");
  const [showVehicleTypeDropdown, setShowVehicleTypeDropdown] = useState(false);
  const vehicleTypeDropdownRef = useRef(null);

  // 2. Vehicle Filter State
  const [selectedVehicleId, setSelectedVehicleId] = useState("");
  const [vehicleSearch, setVehicleSearch] = useState("");
  const [showVehicleDropdown, setShowVehicleDropdown] = useState(false);
  const vehicleDropdownRef = useRef(null);

  // 3. Project Filter State
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [projectSearch, setProjectSearch] = useState("");
  const [showProjectDropdown, setShowProjectDropdown] = useState(false);
  const projectDropdownRef = useRef(null);

  // Modal Search Dropdown States
  const [modalProjectSearch, setModalProjectSearch] = useState("");
  const [showModalProjectDropdown, setShowModalProjectDropdown] = useState(false);
  const modalProjectDropdownRef = useRef(null);

  const [modalVehicleTypeSearch, setModalVehicleTypeSearch] = useState("");
  const [showModalVehicleTypeDropdown, setShowModalVehicleTypeDropdown] = useState(false);
  const modalVehicleTypeDropdownRef = useRef(null);

  const [modalVehicleSearch, setModalVehicleSearch] = useState("");
  const [showModalVehicleDropdown, setShowModalVehicleDropdown] = useState(false);
  const modalVehicleDropdownRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [companyVehicles, setCompanyVehicles] = useState([]);

  const navigate = useNavigate();
  // Page-level message (for table & modify validations)
  const [pageMessage, setPageMessage] = useState("");
  const [pageMsgType, setPageMsgType] = useState("error");

  // Modal-level message (for add / update / form validation)
  const [modalMessage, setModalMessage] = useState("");
  const [modalMsgType, setModalMsgType] = useState("error");

  const [editData, setEditData] = useState(null);
  const [selected, setSelected] = useState();
  const getToday = () => new Date().toISOString().slice(0, 10);

  const [editProjectId, setEditProjectId] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const { register, getValues, reset, setValue, watch } = useForm();


  // Helper: auto-hide page message
  const showPageMessage = (msg, type = "error") => {
    setPageMessage(msg);
    setPageMsgType(type);

    // if (messageTimer) clearTimeout(messageTimer);
    // const timer = setTimeout(() => {
    //   setPageMessage("");
    // }, 3000);
    // setMessageTimer(timer);
  };

  const { permission, can } = usePermission(
    ScreenData.Project_Vehicle,
    showPageMessage
  );

  // const vehicleSuggestions =
  // vehicleSearch.trim()
  //   ? companyVehicles.filter((v) =>
  //       v.vehicleName
  //         ?.toLowerCase()
  //         .includes(vehicleSearch.toLowerCase())
  //     )
  //   : [];


  // Helper: auto-hide modal message
  const showModalMessage = (msg, type = "error") => {
    setModalMessage(msg);
    setModalMsgType(type);

    // if (messageTimer) clearTimeout(messageTimer);
    // const timer = setTimeout(() => {
    //   setModalMessage("");
    // }, 3000);
    // setMessageTimer(timer);
  };

  // Init: load projects & vehicle types
  useEffect(() => {
    const init = async () => {
      try {
        const comp = StorageService.activeCompany();
        const emp = StorageService.loginData();

        let projectsData = [];

        // SUPER ADMIN / DATA ADMIN → ALL COMPANY PROJECTS
        if (
          emp.roleName === "Super Admin" ||
          emp.roleName === "SuperAdmin" ||
          emp.roleName === "Data Admin" ||
          emp.roleName === "DataAdmin" ||
          Number(emp.roleId) === 1 ||
          Number(emp.roleId) === 2
        ) {
          const projRes = await ProjectService.getActive(comp.companyId);
          projectsData = (projRes?.data || projRes || []).map((p) => ({
            id: p.id,
            projectName: p.projectName,
            projectCode: p.projectCode,
          }));
        } else {
          // NORMAL USER → ASSIGNED PROJECTS
          const projRes = await ProjectService.getAssignedProjects(
            comp.companyId,
            emp.employeeId
          );
          projectsData = (
            projRes?.data?.data ||
            projRes?.data ||
            projRes ||
            []
          ).map((p) => ({
            id: p.projectId || p.id,
            projectName: p.projectName,
            projectCode: p.projectCode,
          }));
        }

        setProjects(projectsData);

        const vtRes = await VehicleTypeService.getActiveVehicleTypes();
        setVehicleTypes(vtRes?.data || vtRes || []);
      } catch (err) {
        console.error("Init error:", err);
        showPageMessage("Failed to load initial data", "danger");
      }
    };
    init();
  }, []);

  // useEffect(() => {
  //   const loadPermission = async () => {
  //     const login = StorageService.loginData();

  //     const perm = await EmployeePermissionService.getPermissionsByUserScreen(
  //       login.employeeId,
  //       ScreenData.Project_Vehicle
  //     );

  //     setPermission(perm);
  //   };

  //   loadPermission();
  // }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        vehicleTypeDropdownRef.current &&
        !vehicleTypeDropdownRef.current.contains(e.target)
      ) {
        setShowVehicleTypeDropdown(false);
      }
      if (
        vehicleDropdownRef.current &&
        !vehicleDropdownRef.current.contains(e.target)
      ) {
        setShowVehicleDropdown(false);
      }
      if (
        projectDropdownRef.current &&
        !projectDropdownRef.current.contains(e.target)
      ) {
        setShowProjectDropdown(false);
      }
      if (
        modalProjectDropdownRef.current &&
        !modalProjectDropdownRef.current.contains(e.target)
      ) {
        setShowModalProjectDropdown(false);
      }
      if (
        modalVehicleTypeDropdownRef.current &&
        !modalVehicleTypeDropdownRef.current.contains(e.target)
      ) {
        setShowModalVehicleTypeDropdown(false);
      }
      if (
        modalVehicleDropdownRef.current &&
        !modalVehicleDropdownRef.current.contains(e.target)
      ) {
        setShowModalVehicleDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const loadVehicles = async () => {
      const companyId = StorageService.activeCompany().companyId;
      const res = await VehicleHireService.getByCompanyId(companyId);

      if (res?.status && Array.isArray(res.data)) {
        setCompanyVehicles(res.data);
      } else {
        setCompanyVehicles([]);
      }
    };

    loadVehicles();
  }, []);



  const loadCompanyVehicles = async () => {
    try {
      const companyId = StorageService.activeCompany().companyId;

      const res = await VehicleHireService.getByCompanyId(companyId);
      // 👆 backend should return all vehicles of company

      if (res?.status && Array.isArray(res.data)) {
        setCompanyVehicles(res.data);
      } else {
        setCompanyVehicles([]);
      }
    } catch (err) {
      console.error("Failed to load company vehicles", err);
      setCompanyVehicles([]);
    }
  };


  // Load vehicles by type for dropdown
  const fetchVehicles = async (typeId) => {
    if (!typeId) {
      setVehicles([]);
      return;
    }

    try {
      const companyId = StorageService.activeCompany().companyId;
      const res = await VehicleHireService.getByVehicleTypeId(typeId);

      if (res?.status && Array.isArray(res.data)) {
        const filtered = res.data.filter(
          (v) => String(v.companyId) === String(companyId)
        );

        setVehicles(filtered);
      } else {
        setVehicles([]);
      }
    } catch (err) {
      setVehicles([]);
      showModalMessage("Failed to load vehicles for selected type", "danger");
    }
  };



  // Load assigned vehicles for a project
  // const loadAssignedList = async (projectId) => {
  //   if (!projectId) {
  //     setAssignedVehicles([]);
  //     setSelected([]);
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     const res = await ProjectVehicleService.getAll();
  //     const list = res?.data || res || [];
  //     const filtered =
  //       Array.isArray(list) && list.length
  //         ? list.filter((x) => String(x.projectId) === String(projectId))
  //         : [];

  //     setAssignedVehicles(filtered);
  //     setSelected([]);
  //   } catch (err) {
  //     console.error("Error loading assigned vehicles:", err);
  //     showPageMessage("Failed to fetch assigned vehicles", "danger");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const toLocalDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
    return d.toISOString().slice(0, 10);
  };

  // Edit flow (used by Modify button after selection)
  const editVehicle = async (record) => {
    try {
      const res = await ProjectVehicleService.getById(record.id);
      const data = res?.data?.data || res?.data || res;

      if (!data) {
        showPageMessage("Failed to load vehicle details", "danger");
        return;
      }

      setEditData(data);

      setEditProjectId(data.projectId);

      // Load vehicles dropdown for that type
      await fetchVehicles(data.vehicleTypeId);

      // Auto-fill popup fields
      reset({
        projectId: data.projectId || "",
        vehicleTypeId: data.vehicleTypeId || "",
        vehicleId: data.vehicleId || "",
        startDate: data.startDate ? data.startDate.slice(0, 10) : "",
        releaseDate: data.releaseDate ? data.releaseDate.slice(0, 10) : "",
      });

      setModalProjectSearch("");
      setModalVehicleTypeSearch("");
      setModalVehicleSearch("");
      setShowModalProjectDropdown(false);
      setShowModalVehicleTypeDropdown(false);
      setShowModalVehicleDropdown(false);

      setModalMessage("");
      setShowModal(true);
    } catch (err) {
      console.error("Fetch Modify Error:", err);
      showPageMessage("Couldn't fetch details from server", "danger");
    }
  };

  const handleModify = async () => {
    setPageMessage("");

    if (!selected) {
      showPageMessage("Please select a record to modify.", "danger");
      return;
    }


    const row = filteredAssignedVehicles.find(
      (x) => String(x.id) === String(selected)
    );

    if (!row) {
      showPageMessage("Selected record not found.", "danger");
      return;
    }

    await editVehicle(row);
  };


  useEffect(() => {
    if (permission === null) return;

    if (permission.canView !== 1) {
      setLoading(false);
      return;
    }

    loadAllAssignedVehicles();
  }, [permission]);

  const loadAllAssignedVehicles = async () => {
    setLoading(true);
    try {
      const login = StorageService.loginData();
      const comp = StorageService.activeCompany();
      const res = await ProjectVehicleService.getAll(
        1,
        "all",
        "",
        login?.employeeId,
        login?.roleId,
        comp?.companyId
      );
      setAssignedVehicles(res?.data || []);
    } catch {
      showPageMessage("Failed to fetch assigned vehicles", "danger");
    } finally {
      setLoading(false);
    }
  };



  const handleClearFilters = () => {
    setSelectedVehicleTypeId("");
    setVehicleTypeSearch("");
    setShowVehicleTypeDropdown(false);

    setSelectedVehicleId("");
    setVehicleSearch("");
    setShowVehicleDropdown(false);

    setSelectedProjectId("");
    setProjectSearch("");
    setShowProjectDropdown(false);

    setSelected(undefined);
    setCurrentPage(1);
  };

  const handleAddClick = () => {
    setPageMessage("");
    setEditData(null);
    setSelected(null);

    reset({
      projectId: selectedProjectId || "",
      vehicleTypeId: "",
      vehicleId: "",
      startDate: getToday(),
      releaseDate: "",
    });

    setModalProjectSearch("");
    setModalVehicleTypeSearch("");
    setModalVehicleSearch("");
    setShowModalProjectDropdown(false);
    setShowModalVehicleTypeDropdown(false);
    setShowModalVehicleDropdown(false);

    setModalMessage("");
    setShowModal(true);
  };

  const vehicleNameOnly = vehicleSearch
    ? vehicleSearch.split("---")[0].trim().toLowerCase()
    : "";



  const activeCompanyId = String(StorageService.activeCompany()?.companyId || "");

  const filteredAssignedVehicles = assignedVehicles.filter((v) => {
    let match = true;

    // ✅ Company filter (mandatory)
    if (activeCompanyId) {
      match = match && String(v.companyId) === activeCompanyId;
    }

    // 1. Vehicle Type filter
    if (selectedVehicleTypeId) {
      match =
        match &&
        String(v.vehicleTypeId) === String(selectedVehicleTypeId);
    } else if (vehicleTypeSearch.trim()) {
      match =
        match &&
        v.vehicleType
          ?.toLowerCase()
          .includes(vehicleTypeSearch.trim().toLowerCase());
    }

    // 2. Vehicle filter
    if (selectedVehicleId) {
      match =
        match &&
        String(v.vehicleId) === String(selectedVehicleId);
    } else if (vehicleSearch.trim()) {
      const vSearch = vehicleSearch.trim().toLowerCase();
      match =
        match &&
        (v.vehicleName?.toLowerCase().includes(vSearch) ||
          v.registrationNo?.toLowerCase().includes(vSearch));
    }

    // 3. Project filter
    if (selectedProjectId) {
      match =
        match &&
        String(v.projectId) === String(selectedProjectId);
    } else if (projectSearch.trim()) {
      const pSearch = projectSearch.trim().toLowerCase();
      match =
        match &&
        (v.projectName?.toLowerCase().includes(pSearch) ||
          v.projectCode?.toLowerCase().includes(pSearch));
    }

    return match;
  });

  const pageCount = Math.max(
    1,
    Math.ceil(filteredAssignedVehicles.length / itemsPerPage)
  );

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;

  const currentData = filteredAssignedVehicles.slice(
    indexOfFirst,
    indexOfLast
  );

  useEffect(() => {
    if (currentPage > pageCount) {
      setCurrentPage(1);
    }
  }, [currentPage, pageCount]);

  useEffect(() => {
    setSelected(undefined);
    setCurrentPage(1);
  }, [
    assignedVehicles,
    selectedVehicleTypeId,
    vehicleTypeSearch,
    selectedVehicleId,
    vehicleSearch,
    selectedProjectId,
    projectSearch,
  ]);


  const availableVehicleTypes = React.useMemo(() => {
    if (!companyVehicles || !companyVehicles.length) return vehicleTypes;

    const typeMap = new Map();
    vehicleTypes.forEach((vt) => {
      const vtId = String(vt.id);
      if (companyVehicles.some((v) => String(v.vehicleTypeId) === vtId)) {
        typeMap.set(vtId, vt);
      }
    });

    companyVehicles.forEach((v) => {
      if (v.vehicleTypeId && !typeMap.has(String(v.vehicleTypeId))) {
        typeMap.set(String(v.vehicleTypeId), {
          id: v.vehicleTypeId,
          vehicleType: v.vehicleType || `Type ${v.vehicleTypeId}`
        });
      }
    });

    return typeMap.size > 0 ? Array.from(typeMap.values()) : vehicleTypes;
  }, [companyVehicles, vehicleTypes]);

  const vehicleSuggestions =
    vehicleSearch.trim()
      ? companyVehicles.filter((v) =>
        v.vehicleName
          ?.toLowerCase()
          .includes(vehicleSearch.toLowerCase())
      )
      : companyVehicles;





  const handleSelect = (id) => {
    setSelected(id);
  };

  const handleSave = async () => {
    setModalMessage("");

    const data = getValues();
    // Basic validation
    if (!data.projectId || !data.vehicleTypeId || !data.vehicleId || !data.startDate) {
      showModalMessage("⚠ Please fill all required fields!", "danger");
      return;
    }

    const start = new Date(data.startDate);
    const end = data.releaseDate ? new Date(data.releaseDate) : null;

    if (end && end <= start) {
      showModalMessage("Release Date must be greater than Start Date!", "danger");
      return;
    }
    // -------------------------------

    const payload = {
      projectId: data.projectId,
      vehicleTypeId: data.vehicleTypeId,
      vehicleId: data.vehicleId,
      startDate: data.startDate,
      releaseDate: data.releaseDate || null,
      companyId: StorageService.activeCompany().companyId,
      status: "Active",
      createdBy: StorageService.loginData().employeeId,
      updatedBy: StorageService.loginData().employeeId,
    };

    setLoading(true);

    try {
      if (editData) {
        await ProjectVehicleService.update(editData.id, payload);
        showModalMessage("Vehicle updated successfully!", "success");
      } else {
        await ProjectVehicleService.save(payload);
        showModalMessage("Vehicle assigned successfully!", "success");
      }

      await loadAllAssignedVehicles();

      setTimeout(() => {
        setShowModal(false);
        reset({
          projectId: "",
          vehicleTypeId: "",
          vehicleId: "",
          startDate: "",
          releaseDate: "",
        });
        setEditData(null);
      }, 800);
    } catch (err) {
      console.error("Save Error:", err);

      const backendMsg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Backend Error!";

      showModalMessage(backendMsg, "danger");
    } finally {
      setLoading(false);
    }
  };

  if (permission === null) {
    return <div className="text-center mt-5">Loading...</div>;
  }

  if (!permission || permission.canView !== 1) {
    return <UnAuthorized />;
  }

  return (
    <>
      <Breadcrumb pageTitle="Assign Project Vehicles" secondTitle="Projects" />

      <div className="row">
        {/* Top Filter Card */}
        <div className="card p-3 mb-3">
          <div className="row align-items-end">

            {/* 1. VEHICLE TYPE */}
            <div
              className="col-md-3 position-relative"
              ref={vehicleTypeDropdownRef}
            >
              <label className="form-label mb-1">Vehicle Type</label>

              <input
                type="text"
                className="form-control"
                placeholder="Search Vehicle Type..."
                value={
                  selectedVehicleTypeId
                    ? (
                      vehicleTypes.find(
                        (vt) => String(vt.id) === String(selectedVehicleTypeId)
                      )?.vehicleType || ""
                    )
                    : vehicleTypeSearch
                }
                onFocus={() => setShowVehicleTypeDropdown(true)}
                onChange={(e) => {
                  setVehicleTypeSearch(e.target.value);
                  setSelectedVehicleTypeId("");
                  setShowVehicleTypeDropdown(true);
                  // ✅ Reset Vehicle selection when Vehicle Type changes
                  setSelectedVehicleId("");
                  setVehicleSearch("");
                }}
              />

              {showVehicleTypeDropdown && (
                <div
                  className="position-absolute bg-white border rounded shadow-sm w-100"
                  style={{
                    top: "100%",
                    left: 0,
                    zIndex: 2000,
                    maxHeight: "220px",
                    overflowY: "auto",
                  }}
                >
                  <div
                    className="px-3 py-2 text-primary fw-semibold border-bottom"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setSelectedVehicleTypeId("");
                      setVehicleTypeSearch("");
                      setShowVehicleTypeDropdown(false);
                      // ✅ Reset Vehicle selection when resetting Vehicle Type
                      setSelectedVehicleId("");
                      setVehicleSearch("");
                    }}
                  >
                    All Vehicle Types
                  </div>

                  {vehicleTypes
                    .filter((vt) =>
                      vt.vehicleType
                        ?.toLowerCase()
                        .includes(vehicleTypeSearch.toLowerCase())
                    )
                    .map((vt) => (
                      <div
                        key={vt.id}
                        className="px-3 py-2 border-bottom hover-item"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSelectedVehicleTypeId(vt.id);
                          setVehicleTypeSearch("");
                          setShowVehicleTypeDropdown(false);
                          // ✅ Reset Vehicle selection when selecting a new Vehicle Type
                          setSelectedVehicleId("");
                          setVehicleSearch("");
                        }}
                      >
                        {vt.vehicleType}
                      </div>
                    ))}

                  {vehicleTypes.filter((vt) =>
                    vt.vehicleType
                      ?.toLowerCase()
                      .includes(vehicleTypeSearch.toLowerCase())
                  ).length === 0 && (
                      <div className="px-3 py-2 text-muted">
                        No matching vehicle types
                      </div>
                    )}
                </div>
              )}
            </div>

            {/* 2. VEHICLE */}
            <div
              className="col-md-3 position-relative"
              ref={vehicleDropdownRef}
            >
              <label className="form-label mb-1">Vehicle</label>

              <input
                type="text"
                className="form-control"
                placeholder="Search Vehicle..."
                value={
                  selectedVehicleId
                    ? (() => {
                      const found = companyVehicles.find(
                        (v) =>
                          String(v.vehicleId || v.id) === String(selectedVehicleId)
                      );
                      return found
                        ? `${found.vehicleName}${found.registrationNo ? ` - ${found.registrationNo}` : ""
                        }`
                        : "";
                    })()
                    : vehicleSearch
                }
                onFocus={() => setShowVehicleDropdown(true)}
                onChange={(e) => {
                  setVehicleSearch(e.target.value);
                  setSelectedVehicleId("");
                  setShowVehicleDropdown(true);
                }}
              />

              {showVehicleDropdown && (
                <div
                  className="position-absolute bg-white border rounded shadow-sm w-100"
                  style={{
                    top: "100%",
                    left: 0,
                    zIndex: 2000,
                    maxHeight: "220px",
                    overflowY: "auto",
                  }}
                >
                  <div
                    className="px-3 py-2 text-primary fw-semibold border-bottom"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setSelectedVehicleId("");
                      setVehicleSearch("");
                      setShowVehicleDropdown(false);
                    }}
                  >
                    All Vehicles
                  </div>

                  {companyVehicles
                    .filter((v) => {
                      if (
                        selectedVehicleTypeId &&
                        String(v.vehicleTypeId) !== String(selectedVehicleTypeId)
                      ) {
                        return false;
                      }
                      const term = vehicleSearch.toLowerCase();
                      return (
                        v.vehicleName?.toLowerCase().includes(term) ||
                        v.registrationNo?.toLowerCase().includes(term)
                      );
                    })
                    .map((v) => (
                      <div
                        key={v.vehicleId || v.id}
                        className="px-3 py-2 border-bottom hover-item"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSelectedVehicleId(v.vehicleId || v.id);
                          setVehicleSearch("");
                          setShowVehicleDropdown(false);
                        }}
                      >
                        <div className="fw-semibold">{v.vehicleName}</div>
                        {v.registrationNo && (
                          <div className="text-muted small">
                            {v.registrationNo}
                          </div>
                        )}
                      </div>
                    ))}

                  {companyVehicles.filter((v) => {
                    if (
                      selectedVehicleTypeId &&
                      String(v.vehicleTypeId) !== String(selectedVehicleTypeId)
                    ) {
                      return false;
                    }
                    const term = vehicleSearch.toLowerCase();
                    return (
                      v.vehicleName?.toLowerCase().includes(term) ||
                      v.registrationNo?.toLowerCase().includes(term)
                    );
                  }).length === 0 && (
                      <div className="px-3 py-2 text-muted">
                        No matching vehicles
                      </div>
                    )}
                </div>
              )}
            </div>

            {/* 3. PROJECT */}
            <div
              className="col-md-4 position-relative"
              ref={projectDropdownRef}
            >
              <label className="form-label mb-1">Project</label>

              <input
                type="text"
                className="form-control"
                placeholder="Search Project..."
                value={
                  selectedProjectId
                    ? (() => {
                      const found = projects.find(
                        (p) =>
                          String(p.id || p.projectId) === String(selectedProjectId)
                      );
                      return found
                        ? `${found.projectName}${found.projectCode ? ` - ${found.projectCode}` : ""
                        }`
                        : "";
                    })()
                    : projectSearch
                }
                onFocus={() => setShowProjectDropdown(true)}
                onChange={(e) => {
                  setProjectSearch(e.target.value);
                  setSelectedProjectId("");
                  setShowProjectDropdown(true);
                }}
              />

              {showProjectDropdown && (
                <div
                  className="position-absolute bg-white border rounded shadow-sm w-100"
                  style={{
                    top: "100%",
                    left: 0,
                    zIndex: 2000,
                    maxHeight: "220px",
                    overflowY: "auto",
                  }}
                >
                  <div
                    className="px-3 py-2 text-primary fw-semibold border-bottom"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setSelectedProjectId("");
                      setProjectSearch("");
                      setShowProjectDropdown(false);
                    }}
                  >
                    All Projects
                  </div>

                  {projects
                    .filter((p) => {
                      const term = projectSearch.toLowerCase();
                      return (
                        p.projectName?.toLowerCase().includes(term) ||
                        p.projectCode?.toLowerCase().includes(term)
                      );
                    })
                    .map((p) => (
                      <div
                        key={p.id || p.projectId}
                        className="px-3 py-2 border-bottom hover-item"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSelectedProjectId(p.id || p.projectId);
                          setProjectSearch("");
                          setShowProjectDropdown(false);
                        }}
                      >
                        <div className="fw-semibold">{p.projectName}</div>
                        {p.projectCode && (
                          <div className="text-muted small">
                            {p.projectCode}
                          </div>
                        )}
                      </div>
                    ))}

                  {projects.filter((p) => {
                    const term = projectSearch.toLowerCase();
                    return (
                      p.projectName?.toLowerCase().includes(term) ||
                      p.projectCode?.toLowerCase().includes(term)
                    );
                  }).length === 0 && (
                      <div className="px-3 py-2 text-muted">
                        No matching projects
                      </div>
                    )}
                </div>
              )}
            </div>

            {/* 4. CLEAR FILTERS BUTTON */}
            <div className="col-md-2 d-flex flex-column align-items-start">
              <label className="form-label mb-1 invisible">Clear</label>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClearFilters}
              >
                <i className="ti ti-refresh me-1"></i> Clear
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* Assigned Vehicles Table */}
      <div className="card">
        <div className="card-header d-flex justify-content-between">
          <h5>Assigned Vehicles</h5>

          <div>
            {can("canAdd") && (
              <button
                className="btn btn-success me-2"
                onClick={handleAddClick}
              >
                <i className="ti ti-plus me-1"></i> Add Vehicles
              </button>
            )}

            {can("canModify") && (
              <button
                className="btn btn-warning"
                onClick={handleModify}
                disabled={!selected}
              >
                <i className="ti ti-pencil me-1"></i> Modify
              </button>
            )}
          </div>
        </div>

        <div className="card-body">
          {/* Page Message */}
          {/* {pageMessage && (
            <div
              className={`alert alert-${pageMsgType} d-flex justify-content-between align-items-center py-2`}
            >
              <span>{pageMessage}</span>
              <button
                type="button"
                className="btn-close"
                onClick={() => setPageMessage("")}
              ></button>
            </div>
          )} */}


          <MessageDialog
            message={pageMessage || modalMessage}
            type={
              (pageMsgType === "success" || modalMsgType === "success")
                ? "success"
                : "error"
            }
            setMessage={() => {
              setPageMessage("");
              setModalMessage("");
            }}
            setMsgType={() => { }}
          />



          <table className="table table-bordered">
            <thead>
              <tr>
                <th></th>
                <th>Project</th>
                <th>Vehicle Type</th>
                <th>Vehicle</th>
                <th>Start Date</th>
                <th>Release Date</th>
                {/* <th>Status</th> */}
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="text-center py-4">
                    <Loading />
                  </td>
                </tr>
              ) : filteredAssignedVehicles.length > 0 ? (
                // filteredAssignedVehicles.map((v) => (
                currentData.map((v) => (
                  <tr key={v.id}>
                    <td>
                      <input
                        type="radio"
                        checked={selected === v.id}
                        onChange={() => handleSelect(v.id)}
                      />
                    </td>

                    {/* ✅ PROJECT */}
                    <td>{v.projectName} - {v.projectCode}</td>

                    {/* ✅ VEHICLE TYPE */}
                    <td>{v.vehicleType || "-"}</td>

                    {/* ✅ VEHICLE */}
                    <td>{v.vehicleName} - {v.registrationNo}</td>

                    <td>
                      {v.startDate
                        ? utility.formatDateDDMMMYYYY(v.startDate)
                        : "-"}
                    </td>

                    <td>
                      {v.releaseDate
                        ? utility.formatDateDDMMMYYYY(v.releaseDate)
                        : "—"}
                    </td>

                    {/* <td>
                      <span className={`badge ${v.status === "Active"
                        ? "bg-success"
                        : "bg-secondary"}`}>
                        {v.status}
                      </span>
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-muted">
                    No assigned vehicles
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3">
            <ReactPaginate
              forcePage={currentPage - 1}
              breakLabel="..."
              nextLabel="Next >"
              previousLabel="< Previous"
              onPageChange={(e) => setCurrentPage(e.selected + 1)}
              pageCount={pageCount}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              containerClassName="pagination-container mb-0"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
            />

            <div className="text-muted" style={{ fontSize: "15px" }}>
              Showing <strong>{filteredAssignedVehicles.length === 0 ? 0 : indexOfFirst + 1}</strong> to{" "}
              <strong>{Math.min(indexOfLast, filteredAssignedVehicles.length)}</strong> of{" "}
              <strong>{filteredAssignedVehicles.length}</strong> vehicles
            </div>
          </div>
        </div>
      </div>

      {/* POPUP MODAL */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            zIndex: 999,
          }}
        >
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "420px",
              background: "#fff",
              padding: "20px",
              borderRadius: "8px",
            }}
          >
            <h5>{editData ? "Modify Vehicle" : "Assign Vehicle"}</h5>

            {/* Project */}
            <div
              className="mb-3 position-relative"
              ref={modalProjectDropdownRef}
            >
              <label className="form-label mb-1">
                Project <span className="text-danger">*</span>
              </label>

              <input
                type="text"
                className="form-control"
                placeholder="Select Project"
                value={
                  watch("projectId")
                    ? (() => {
                      const found = projects.find(
                        (p) =>
                          String(p.id || p.projectId) === String(watch("projectId"))
                      );
                      return found
                        ? `${found.projectName}${found.projectCode ? `-${found.projectCode}` : ""
                        }`
                        : "";
                    })()
                    : modalProjectSearch
                }
                onFocus={() => setShowModalProjectDropdown(true)}
                onChange={(e) => {
                  setModalProjectSearch(e.target.value);
                  setValue("projectId", "");
                  setValue("vehicleTypeId", "");
                  setValue("vehicleId", "");
                  setVehicles([]);
                  setShowModalProjectDropdown(true);
                }}
              />

              {showModalProjectDropdown && (
                <div
                  className="position-absolute bg-white border rounded shadow-sm w-100"
                  style={{
                    top: "100%",
                    left: 0,
                    zIndex: 2050,
                    maxHeight: "200px",
                    overflowY: "auto",
                  }}
                >
                  {projects
                    .filter((p) => {
                      const term = modalProjectSearch.toLowerCase();
                      return (
                        p.projectName?.toLowerCase().includes(term) ||
                        p.projectCode?.toLowerCase().includes(term)
                      );
                    })
                    .map((p) => (
                      <div
                        key={p.id || p.projectId}
                        className="px-3 py-2 border-bottom hover-item"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          const projId = p.id || p.projectId;
                          setValue("projectId", projId);
                          setValue("vehicleTypeId", "");
                          setValue("vehicleId", "");
                          setVehicles([]);
                          setModalProjectSearch("");
                          setShowModalProjectDropdown(false);
                        }}
                      >
                        <div className="fw-semibold">{p.projectName}</div>
                        {p.projectCode && (
                          <div className="text-muted small">
                            {p.projectCode}
                          </div>
                        )}
                      </div>
                    ))}

                  {projects.filter((p) => {
                    const term = modalProjectSearch.toLowerCase();
                    return (
                      p.projectName?.toLowerCase().includes(term) ||
                      p.projectCode?.toLowerCase().includes(term)
                    );
                  }).length === 0 && (
                      <div className="px-3 py-2 text-muted">
                        No matching projects
                      </div>
                    )}
                </div>
              )}
            </div>

            {/* Vehicle Type */}
            <div
              className="mb-3 position-relative"
              ref={modalVehicleTypeDropdownRef}
            >
              <label className="form-label mb-1">
                Vehicle Type <span className="text-danger">*</span>
              </label>

              <input
                type="text"
                className="form-control"
                placeholder={
                  !watch("projectId")
                    ? "Select project first"
                    : "Select Vehicle Type"
                }
                disabled={!watch("projectId")}
                value={
                  watch("vehicleTypeId")
                    ? (
                      availableVehicleTypes.find(
                        (v) => String(v.id) === String(watch("vehicleTypeId"))
                      )?.vehicleType || ""
                    )
                    : modalVehicleTypeSearch
                }
                onFocus={() => {
                  if (watch("projectId")) setShowModalVehicleTypeDropdown(true);
                }}
                onChange={(e) => {
                  setModalVehicleTypeSearch(e.target.value);
                  setValue("vehicleTypeId", "");
                  setValue("vehicleId", "");
                  setShowModalVehicleTypeDropdown(true);
                }}
              />

              {showModalVehicleTypeDropdown && watch("projectId") && (
                <div
                  className="position-absolute bg-white border rounded shadow-sm w-100"
                  style={{
                    top: "100%",
                    left: 0,
                    zIndex: 2050,
                    maxHeight: "200px",
                    overflowY: "auto",
                  }}
                >
                  {availableVehicleTypes
                    .filter((v) =>
                      v.vehicleType
                        ?.toLowerCase()
                        .includes(modalVehicleTypeSearch.toLowerCase())
                    )
                    .map((v) => (
                      <div
                        key={v.id}
                        className="px-3 py-2 border-bottom hover-item"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          const typeId = v.id;
                          setValue("vehicleTypeId", typeId);
                          setValue("vehicleId", "");
                          fetchVehicles(typeId);
                          setModalVehicleTypeSearch("");
                          setShowModalVehicleTypeDropdown(false);
                        }}
                      >
                        {v.vehicleType}
                      </div>
                    ))}

                  {availableVehicleTypes.filter((v) =>
                    v.vehicleType
                      ?.toLowerCase()
                      .includes(modalVehicleTypeSearch.toLowerCase())
                  ).length === 0 && (
                      <div className="px-3 py-2 text-muted">
                        No matching vehicle types
                      </div>
                    )}
                </div>
              )}
            </div>

            {/* Vehicle */}
            <div
              className="mb-3 position-relative"
              ref={modalVehicleDropdownRef}
            >
              <label className="form-label mb-1">
                Vehicle <span className="text-danger">*</span>
              </label>

              <input
                type="text"
                className="form-control"
                placeholder={
                  !watch("projectId")
                    ? "Select project first"
                    : !watch("vehicleTypeId")
                      ? "Select vehicle type first"
                      : "Select Vehicle"
                }
                disabled={!watch("projectId") || !watch("vehicleTypeId")}
                value={
                  watch("vehicleId")
                    ? (() => {
                      const found = vehicles.find(
                        (v) =>
                          String(v.vehicleId || v.id) === String(watch("vehicleId"))
                      );
                      return found
                        ? `${found.vehicleName}${found.registrationNo ? ` - ${found.registrationNo}` : ""
                        }`
                        : "";
                    })()
                    : modalVehicleSearch
                }
                onFocus={() => {
                  if (watch("projectId") && watch("vehicleTypeId")) {
                    setShowModalVehicleDropdown(true);
                  }
                }}
                onChange={(e) => {
                  setModalVehicleSearch(e.target.value);
                  setValue("vehicleId", "");
                  setShowModalVehicleDropdown(true);
                }}
              />

              {showModalVehicleDropdown &&
                watch("projectId") &&
                watch("vehicleTypeId") && (
                  <div
                    className="position-absolute bg-white border rounded shadow-sm w-100"
                    style={{
                      top: "100%",
                      left: 0,
                      zIndex: 2050,
                      maxHeight: "200px",
                      overflowY: "auto",
                    }}
                  >
                    {vehicles.length > 0 ? (
                      vehicles
                        .filter((v) => {
                          const term = modalVehicleSearch.toLowerCase();
                          return (
                            v.vehicleName?.toLowerCase().includes(term) ||
                            v.registrationNo?.toLowerCase().includes(term)
                          );
                        })
                        .map((v) => (
                          <div
                            key={v.vehicleId || v.id}
                            className="px-3 py-2 border-bottom hover-item"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              const vehId = v.vehicleId || v.id;
                              setValue("vehicleId", vehId);
                              setModalVehicleSearch("");
                              setShowModalVehicleDropdown(false);
                            }}
                          >
                            <div className="fw-semibold">{v.vehicleName}</div>
                            {v.registrationNo && (
                              <div className="text-muted small">
                                {v.registrationNo}
                              </div>
                            )}
                          </div>
                        ))
                    ) : (
                      <div className="px-3 py-2 text-muted">
                        No vehicles found for this type
                      </div>
                    )}
                  </div>
                )}
            </div>

            {/* Start Date */}
            <div className="mb-3">
              <label className="form-label">Start Date <span className="text-danger">*</span></label>
              <input
                type="date"
                className="form-control"
                {...register("startDate")}
              />
            </div>

            {/* Release Date */}
            <div className="mb-3">
              <label className="form-label">Release Date</label>
              <input
                type="date"
                className="form-control"
                {...register("releaseDate")}
              />
            </div>

            {/* Buttons */}
            <div className="d-flex justify-content-end gap-2">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowModal(false);
                  setEditData(null);
                  reset({
                    projectId: "",
                    vehicleTypeId: "",
                    vehicleId: "",
                    startDate: "",
                    releaseDate: "",
                  });
                  setModalProjectSearch("");
                  setModalVehicleTypeSearch("");
                  setModalVehicleSearch("");
                  setShowModalProjectDropdown(false);
                  setShowModalVehicleTypeDropdown(false);
                  setShowModalVehicleDropdown(false);
                }}
              >
                <i className="ti ti-cancel me-1"></i>
                Cancel
              </button>

              <button className="btn btn-primary" onClick={handleSave}
                disabled={loading}>
                <i className="ti ti-circle-check me-1"></i>
                {loading
                  ? editData
                    ? "Updating..."
                    : "Saving..."
                  : editData
                    ? "Update"
                    : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
